module.exports = __webpack_public_path__ + "img/workstation.48874e44.svg";